// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./consentListTableFooter.scss";
// project file imports(UI components) ⇒
import FooterPagination from "../../../../common/FooterPagination";
// const file imports(helper methods, etc) ⇒

function ConsentListTableFooter(props) {
  // const declarations ⇒
  const { activePage, setActivePage, totalRecordCount } = props;
  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  const onPageChange = (index) => {
    setActivePage(index);
  };
  // Actions ⇒

  // create UI ⇒

  //

  return (
    <div className="consent-list-footer-pafination">
      <FooterPagination
        pageSize={10}
        hideShowRecords={true}
        currentPage={activePage}
        totalCount={totalRecordCount}
        onPageChange={onPageChange}
      />
    </div>
  );
}

export default ConsentListTableFooter;
